<template>
    <b-card no-body :header-bg-variant="headerBGVariant">
      <b-card-header>
        <h4>Section History</h4>
      </b-card-header>

        <b-card-body>
          <b-form>
            <rx-number-input
                v-model="lastPCRYear"
                title-text="Last PCR Year"
                description="Enter the year the last known PCR reading was taken. Readings older than 4 years may trigger a warning from RxPave, as the actual PCR value naturally decreases with pavement age. "
                id="lastPCRYEar"
                :validation="$v.lastPCRYear"
            ></rx-number-input>

            <rx-number-input
                v-model="lastPCRReading"
                title-text="Last PCR Reading"
                description="Enter the the last known PCR reading (0-100). RxPave uses the PCR score to qualify or disqualify rehabilitation options."
                id="lastPCRReading"
                :validation="$v.lastPCRReading"
            ></rx-number-input>

            <rx-number-input
                v-model="lastTreatmentYear"
                title-text="Last Treatment Year"
                description="Enter the year the last known maintenance or treatment activity was performed on your segment. If the last treatment was too recent, the treatment activity may be underperforming compared to its intended design life. RxPave will note this warning in the final report."
                id="lastTreatmentYear"
                :validation="$v.lastTreatmentYear"
            ></rx-number-input>

            <rx-dropdown
                v-model="lastKnownTreatment"
                :options="treatmentOptions"
                title-text="Last Known Treatment Type"
                description="Enter the year the last known maintenance or treatment activity was performed on your segment. RxPave may provide additional considerations in the final report based on your responses to last known treatments."
                id="lastKnownTreatment"
                :validation="$v.lastKnownTreatment"
            ></rx-dropdown>

            <b-alert v-for="w in warnings" show variant="warning">
              <strong>Warning:</strong> {{ w.message }}
            </b-alert>

          </b-form>
        </b-card-body>
    </b-card>
</template>

<script>
  import { mapFields } from "vuex-map-fields";

  import { mapMutations } from 'vuex'
  // const { mapMutations } = createNamespacedHelpers('rx');

  import { validationMixin } from 'vuelidate';
  import { required, between} from 'vuelidate/lib/validators'
  import {isValidSection2b} from "../../../js/validation/projectValidation";

  import RxTextEntryBox from './inputComponents/RxTextEntryBox.vue'
  import RxDropdown from './inputComponents/RxDropdown.vue'
  import RxNumberInput from './inputComponents/RxNumberInput.vue'
  import RxRadio from './inputComponents/RxRadio.vue'



  import { checkLastKnownTreatment } from './../../../js/validation/lastKnownTreatment.js'
  import {
    checkPcrRecentEnough,
    checkPcrMoreRecentThanLastTreatment
  } from './../../../js/validation/lastPCR.js'


  const currYear = () => {
    const d = new Date();
    return d.getFullYear()
  };

  export default {
    name: "Section2B",

    components: {
      RxDropdown: RxDropdown,
      RxNumberInput: RxNumberInput,
    },
    mixins: [
      validationMixin
    ],
    props:{
      value: {
        type: String
      },
      $v: {
        type: Object
      }
    },

    data() {
      return {
        treatmentOptions: [
          {text: "Unsure / I don't know", value: 0},
          {text: "Overlay (or FDR with Overlay)", value: 1},
          {text: "Chip / Cape Seal (or FDR with Chip/Cape Seal)", value: 2},
          {text: "New Construction or Full Reconstruction", value: 3}
        ],
        headerBGVariant: null,
        cardBorderVariant: 'dark',
        headerTextVariant: 'dark'
      };
    },

    computed: {
      ...mapFields('rx',[
        "currentProject",
        "currentProject.lastPCRYear",
        "currentProject.lastPCRReading",
        "currentProject.lastTreatmentYear",
        "currentProject.lastKnownTreatment",
      ]),
      isValid: function() {
        return !this.$v.$invalid;
      },
      warnings(){
        const warningList = [];

        const age = currYear() - this.lastTreatmentYear;
        const treatmentWarnings = checkLastKnownTreatment(this.lastKnownTreatment, age);
        if (treatmentWarnings.length > 0){
          warningList.push(...treatmentWarnings);
        }

        if (!this.$v.lastPCRYear.$invalid && !this.$v.lastTreatmentYear.$invalid){
          const pcrMoreRecent = checkPcrMoreRecentThanLastTreatment(this.lastPCRYear, this.lastTreatmentYear)
          if (pcrMoreRecent !== null){
            warningList.push(pcrMoreRecent)
          }
        }

        if (!this.$v.lastPCRYear.$invalid){
          const pcrRecentEnough = checkPcrRecentEnough(this.lastPCRYear)
          if (pcrRecentEnough !== null){
            warningList.push(pcrRecentEnough)
          }
        }

        return warningList.length > 0 ? warningList : null
      }
    },

    updated: function () {
      this.setValid();
      // this.setCardStyle();
    },

    methods:{
      ...mapMutations('rx',[
        'validateProjectState',
        'setValidSection'
      ]),
      validateLastKnownTreatment: function(){
        return
      },
      setCardStyle: function(){
        if (!this.$v.$invalid){
          this.headerBGVariant= 'success';
        } else if (this.$v.$anyError){
          this.headerBGVariant= 'warning';
        } else {
          this.headerBGVariant= 'light';
        }
      },
      setValid(){
        console.log("Section 2B field validators match store validation:",
          isValidSection2b(this.currentProject) === !this.$v.$invalid);
        this.setValidSection({
          section: '2b',
          value: !this.$v.$invalid
        })
      }
    },
  }
</script>

<style scoped>

</style>